import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { Chips } from 'primereact/chips';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

interface PlateFieldProps {
  control: Control<NewMessageFormData>;
  t: (key: string) => string;
  styles: Record<string, string>;
}

const PlateField: FC<PlateFieldProps> = ({ control, t, styles }) => (
  <div className={styles['form-section']}>
    <label>{t('messages.mailbox.recipientTypes.plate.label')}</label>
    <Controller
      name="numberPlates"
      control={control}
      rules={{ required: t('messages.validations.required') }}
      render={({ field, fieldState }) => (
        <>
          <Chips
            value={field.value || []}
            onChange={(e) => field.onChange(e.value)}
            placeholder={t('messages.mailbox.recipientTypes.plate.description')}
            className={fieldState.invalid ? 'p-invalid' : ''}
            separator=","
          />
          {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
        </>
      )}
    />
  </div>
);

export default PlateField;
